import { ELEMENT_HR, ELEMENT_IMAGE } from '@udecode/plate';
import { MARK_BOLD, MARK_CODE, MARK_ITALIC, MARK_STRIKETHROUGH } from '@udecode/plate';
import { ELEMENT_BLOCKQUOTE } from '@udecode/plate';
import { getPluginType, PlateEditor } from '@udecode/plate';
import {
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_H4,
  ELEMENT_H5,
  ELEMENT_H6,
} from '@udecode/plate';
import { ELEMENT_LINK } from '@udecode/plate';
import { ELEMENT_LI, ELEMENT_OL, ELEMENT_UL } from '@udecode/plate';
import { ELEMENT_PARAGRAPH } from '@udecode/plate';
import markdown from 'remark-parse';
import slate from 'remark-slate';
import unified from 'unified';

import { ELEMENT_CODE_HIGHLIGHT_BLOCK } from '../../code-highlight-block';
/**
 * Deserialize content from Markdown format to Slate format.
 * `editor` needs
 */
export const deserializeMd = (editor: PlateEditor, data: string) => {
  const tree: any = unified()
    .use(markdown)
    .use(slate, {
      nodeTypes: {
        thematic_break: getPluginType(editor, ELEMENT_HR),
        paragraph: getPluginType(editor, ELEMENT_PARAGRAPH),
        block_quote: getPluginType(editor, ELEMENT_BLOCKQUOTE),
        link: getPluginType(editor, ELEMENT_LINK),
        inline_code_mark: getPluginType(editor, MARK_CODE),
        emphasis_mark: getPluginType(editor, MARK_ITALIC),
        strong_mark: getPluginType(editor, MARK_BOLD),

        strong: getPluginType(editor, MARK_BOLD),
        delete_mark: getPluginType(editor, MARK_STRIKETHROUGH),
        image: getPluginType(editor, ELEMENT_IMAGE),
        // FIXME: underline, subscript superscript not yet supported by remark-slate
        // underline: getPluginType(editor, MARK_UNDERLINE),
        // subscript: getPluginType(editor, MARK_SUBSCRIPT),
        // superscript: getPluginType(editor, MARK_SUPERSCRIPT),
        code_block: getPluginType(editor, ELEMENT_CODE_HIGHLIGHT_BLOCK),
        ul_list: getPluginType(editor, ELEMENT_UL),
        ol_list: getPluginType(editor, ELEMENT_OL),
        listItem: getPluginType(editor, ELEMENT_LI),
        heading: {
          1: getPluginType(editor, ELEMENT_H1),
          2: getPluginType(editor, ELEMENT_H2),
          3: getPluginType(editor, ELEMENT_H3),
          4: getPluginType(editor, ELEMENT_H4),
          5: getPluginType(editor, ELEMENT_H5),
          6: getPluginType(editor, ELEMENT_H6),
        },
      } as any,
      linkDestinationKey: 'url',
      imageSourceKey: 'url',
      imageCaptionKey: 'alt',
    })
    .processSync(data);
  return normalizeNodes(tree.result);
};

function removeParagraphTypeIfPresent(node) {
  if (node.type === ELEMENT_PARAGRAPH) {
    delete node.type;
  }
  node?.children?.map((n) => removeParagraphTypeIfPresent(n));
}

function formatCodeHighlightElement(node) {
  if (node?.children?.[0]?.text) {
    node.code = node.children[0].text;
    node.children = [{ text: '' }];
  }
}

function normalizeNodes(nodes: any[]) {
  nodes.map((node, index) => {
    if (node.type === ELEMENT_CODE_HIGHLIGHT_BLOCK) {
      formatCodeHighlightElement(node);
    }
    node?.children?.map((n) => removeParagraphTypeIfPresent(n));
    if (!node.type) {
      nodes.splice(index, 1);
    }
    if (node.type === ELEMENT_PARAGRAPH) {
      // second level
      node.children.map((child, childIndex) => {
        if (child.type === ELEMENT_IMAGE) {
          nodes.splice(index, 0, child);
          node.children.splice(childIndex, 1);
        }
        if (!node.children[0]?.text && !node.children[0]?.children) {
          nodes.splice(index, 1);
        }
      });
    }
  });
  return nodes;
}
